import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { AuthFailureComponent } from './views/auth-failure/auth-failure.component';
import { ViewsComponent } from './views/views.component';
import { ViewsChilRoutes } from './views/views.routing';

const routes: Routes = [
  {
    path: 'auth-failure',
    component: AuthFailureComponent,
  },
  {
    path: '',
    component: ViewsComponent,
    children: ViewsChilRoutes,
    canActivate: [MsalGuard],
  },
];

const isIframe = window !== window.parent && !window.opener;

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: !isIframe ? 'enabled' : 'disabled', // Don't perform initial navigation in iframes
  })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
